import CityPageTemplate from "@/components/site/CityPageTemplate";

export default function FinanzberatungSchwerin() {
  return (
    <CityPageTemplate
      city="Schwerin"
      slug="schwerin"
      intro="Schwerin als Landeshauptstadt Mecklenburg-Vorpommerns mit seinem malerischen Schloss – Deine Finanzen sollten genauso imposant sein."
      description="Unabhängige & digitale Finanzberatung für Schwerin: Altersvorsorge, ETF, Steueroptimierung und staatliche Förderungen. Kostenlose Erstberatung – 100% digital."
    />
  );
}
